<template lang="pug">
  m-table(
    store-name="adminsignatures"
    :items-per-page="-1"
    :headers="headers"
    :query-filter="queryFilter"
  )
</template>

<script>
import MTable from '~/components/modules/tables/m-table'

export default {
  name: 'BlockDocumentSignatures',
  components: { MTable },
  props: {
    documentId: {
      type: String,
      default: null
    }
  },
  computed: {
    headers() {
      return [
        {
          text: 'Organization name',
          value: 'organizationName',
          sortable: false,
          filterable: false
        },
        {
          text: 'Full name',
          value: 'userName',
          sortable: false,
          filterable: false
        },
        {
          text: 'EDRPOU',
          value: 'edrpou',
          sortable: false,
          filterable: false
        },
        {
          text: 'DRFO',
          value: 'drfo',
          sortable: false,
          filterable: false
        },
        {
          text: 'Position',
          value: 'position',
          sortable: false,
          filterable: false
        },
        {
          text: 'Stamp',
          value: 'isStamp',
          valueFormatter: signature => (signature.isStamp ? this.$t('Yes') : this.$t('No')),
          sortable: false,
          filterable: false
        },
        {
          text: 'Date of singing',
          value: 'signedAt',
          valueFormatter: signature =>
            this.$moment.parseZone(signature.signedAt).format('DD.MM.YYYY HH:mm'),
          sortable: false,
          filterable: false
        }
      ]
    },
    queryFilter() {
      return {
        'document.id': this.documentId
      }
    }
  }
}
</script>

<style scoped lang="scss"></style>
